var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('MwList',{attrs:{"storeModule":"categories","columns":_vm.headers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }